import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { RequestHelper } from '@helper/request.helper';
import { NavigationConstant } from '@constant/navigation.constant';
import { APIConstant } from '@constant/api.constant';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageConstant } from '@constant/message.constant';
import { BniStorage } from '@shared/storage/bni.storage';

@Component({
    selector: 'app-inquiry-bni',
    templateUrl: './inquiry-bni.component.html',
    styleUrls: ['./inquiry-bni.component.css']
  })

export class InquiryBniComponent implements OnInit {
  form: FormGroup;
  inquiryResponse: any;
  isLoading: boolean;
  isSubmitted: boolean;
  hostname: any = environment.hostName;

  maxLength: number = 23;
  imagePath = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/bank/bni.png';
  moduleName = 'BNI VA';

  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private bniStorage: BniStorage
  ) {
    this.isLoading = false;
    this.isSubmitted = false;
  }

  ngOnInit() {
    this.form = new FormBuilder().group({
      vaNumber: [null, [Validators.required, Validators.maxLength(this.maxLength)]]
    });
  }

  submitInquiry(){
    this.isSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    console.log('value ', this.form.get('vaNumber').value)
    let vaNumber = this.form.get('vaNumber').value;
    this.apiService.get(environment.apiUrl + APIConstant.BNI_PAYMENT_NOTIFICATION + "/" +vaNumber).subscribe((data) => {
       console.log('data get BNI from BE ', data);
       this.getDataResponse(data);
    }, (err) => {
      console.log('error get data BNI BE ', err)
    });
  }

  getDataResponse(data: any) {
    console.log("data from getDataResponse -> "+JSON.stringify(data));
    if (data.virtual_account != null) {
      localStorage.setItem('bni_result_inquiry', JSON.stringify(data));
      return this.router.navigate([NavigationConstant.BNI_PAYMENT]);
    } else if (data.code === '404') {
      this.openDialog(MessageConstant.NOT_FOUND);
    } else if(data.status === '500') {
      this.openDialog(MessageConstant.CANNOT_PROCESS);
    }else {
      this.openDialog(MessageConstant.CANNOT_PROCESS);
    }
  }

  goHome() {
    this.router.navigate([NavigationConstant.HOME]);
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.BNI_INQUIRY);
  }
}